"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { WorkspaceElementType } from '@membranehq/sdk';
import { useElement } from '../element/useElement.mjs';

function useFlow(selector) {
  const {
    item: flow,
    accessor,
    refresh,
    ...rest
  } = useElement(
    WorkspaceElementType.Flow,
    selector,
    (integrationApp) => selector ? integrationApp.flow(selector) : void 0
  );
  async function reset() {
    await accessor?.reset();
    return await refresh();
  }
  return { flow, reset, refresh, accessor, ...rest };
}

export { useFlow };
